import { memo, useState } from 'react'

import styled, { keyframes } from 'styled-components'

import CrossIcon from 'assets/svgr-icons/Close.svg'
import { IProps } from './types' //  once this was an orphan type

const CenteredIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const rotateAnimation = keyframes`
  0% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(270deg);
  }
`

const InfiniteCircle = styled.circle`
  animation: ${rotateAnimation} 1.5s linear infinite;
  transform-origin: center;
`

const RADIUS = 45
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

const SvgCircle: React.FC<IProps> = props => {
  const {
    progress,
    strokeColor,
    strokeWidth,
    size,
    showText = false,
    textColor = '#000000',
    backgroundColor = '#FFFFFF', // Can use rgba(255,255,255,0.5) for transparency
    roundedCaps = false,
    enableHoverEffect = false,
    onClick = () => {},
    infiniteLoading = false
  } = props

  const [isHovered, setIsHovered] = useState(false)
  const strokeDashoffset = CIRCUMFERENCE * (1 - progress / 100)

  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => enableHoverEffect && setIsHovered(true)}
      onMouseLeave={() => enableHoverEffect && setIsHovered(false)}
    >
      {/* Background circle (unloaded portion) */}
      <circle
        cx="50"
        cy="50"
        r={RADIUS}
        stroke={backgroundColor}
        strokeWidth={strokeWidth}
        fill="none"
      />

      {/* Foreground circle (loaded portion) */}
      {infiniteLoading ? (
        <InfiniteCircle
          cx="50"
          cy="50"
          r={RADIUS}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={`${CIRCUMFERENCE * 0.75} ${CIRCUMFERENCE * 0.25}`}
          strokeLinecap={roundedCaps ? 'round' : 'butt'}
        />
      ) : (
        <circle
          cx="50"
          cy="50"
          r={RADIUS}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90 50 50)"
          strokeLinecap={roundedCaps ? 'round' : 'butt'}
        />
      )}

      {showText &&
        !infiniteLoading &&
        (isHovered && enableHoverEffect ? (
          <foreignObject x="32" y="32" width="36" height="36">
            <CenteredIconWrapper>
              <CrossIcon />
            </CenteredIconWrapper>
          </foreignObject>
        ) : (
          <text
            x="50"
            y="50"
            textAnchor="middle"
            dominantBaseline="middle"
            fill={textColor}
            fontSize={16}
            fontWeight={600}
          >
            {`${Math.round(progress)} %`}
          </text>
        ))}
    </svg>
  )
}

export default memo(SvgCircle)
